export const SUPER_ADMIN = 1;
export const MASTER_ADMIN = 2;
export const ADMIN = 3;
export const ADMINISTRATOR = 1;
export const MANAGER = 1;
